module.exports = "<p>\n  security-stocks works!\n</p>\n"